module.exports = __webpack_public_path__ + "img/footer-fisa-pacient.0db1ba5f.jpg";